export const MenuList = [
    {
        title: 'Dashboard',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-home " />,
        content: [
            {
                title: 'Dashboard ',
                to: 'dashboard',
            },
        ],
    },
    {
        title: 'User Management',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-user" aria-hidden="true" />,
          isDropdown: true,
        content: [
            {
                title: 'Astrologers',
                to: 'astrolist',

            },
            {
                title: 'User',
                to: 'userlist',
            },
            {
                title: 'Admin User',
                to: 'AdminUserList',
            },


        ],
    },
    {
        title: 'Astrology Services',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-star"></i>,
          isDropdown: true,
        content: [
            {
                title: 'Booking Poja List',
                to: 'PujaListFilter',

            },
            {
                title: 'Gemstone Order List',
                to: 'GemstoneListFilter',
            },
            {
                title: 'Poja For',
                to: 'PoojaFor',
            },
            {
                title: 'Astrologer Gallery',
                to: 'astrogallery',
            },
        ],
    },
    {
        title: 'Call-Chat History',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-phone" aria-hidden="true" />,
        content: [
            {
                title: 'Call History',
                to: 'CallHistory',
            },
            {
                title: 'Chat History',
                to: 'ChatHistory',
            },
        ],
    },
    {
        title: 'Push Notification',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-bell" aria-hidden="true"></i>,
        content: [
            {
                title: 'CategoryNotification',
                to: 'CategoryNotification',
            },
            {
                title: 'PushNotification',
                to: 'DataPushNotification',
            },
            // 
            {
                title: 'Notification Rule List',
                to: 'notificationrulelist',
            }

        ],
    },

    {
        title: 'Content Management',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-tasks" aria-hidden="true"></i>,
        content: [
            {
                title: 'Blog',
                to: 'Blog',
            },
            {
                title: 'Privacy Policy',
                to: 'policy',
            },
            {
                title: 'Horoscope',
                to: 'Horoscope',
            },
            {
                title: 'Muhurat',
                to: 'Muhurat',
            },

            {
                title: 'VratUpvaas',
                to: 'VratUpvaas',
            },
            {
                title: 'Festival',
                to: 'festival',
            },
        ],
    },

    {
        title: 'Master Tables',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-table" aria-hidden="true"></i>,
        content: [
            {
                title: 'Skills',
                to: 'SkillsList',
            },
            {
                title: 'Languages',
                to: 'LanguagesList',
            },
            {
                title: 'Blog Category',
                to: 'BlogCategoryList',
            },
            {
                title: 'Muhurat Category',
                to: 'MuhuratCategory',
            },
            {
                title: 'Dregee Diploma',
                to: 'DregeeDiploma',
            },
            {
                title: 'Astrologers Category',
                to: 'AstrologersCategory',
            },

            {
                title: 'Gemstone Category',
                to: 'Gemstone',
            },

            {
                title: 'Gemstone Order List',
                to: 'GemstoneUserList',
            },
            {
                title: 'Gemstone Cart List',
                to: 'GemstoneCartList',
            },




           

            {
                title: 'Vrat Upvaas',
                to: 'VratUpvaasCategory',
            },





          
            {
                title: 'Expense ',
                to: 'ExpenseCategory',
            },
            {
                title: 'Transaction ',
                to: 'TransactionCategory',
            },
            {
                title: 'Income ',
                to: 'IncomeCategory',
            },
        ],
    },

    {
        title: 'Home Page Frontend',
        classsChange: 'mm-collapse',
        iconStyle: <i className="fas fa-home" />,
        content: [
            {
                title: 'Home Slider',
                to: 'HomeSlider',
            },
            {
                title: 'Customer Feedback',
                to: 'Feedback',
            },
            {
                title: 'Trusted by Populars Videos',
                to: 'Video',
            },
            {
                title: 'HomePage Pooja',
                to: 'PoojaList',
            },
            {
                title: 'HomePage Gemstone',
                to: 'GemstoneList',
            },
            {
                title: 'Contact',
                to: 'Contact',
            },

        ],
    },
    {
        title: 'Payment & Transaction',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-credit-card" aria-hidden="true"></i>,
        content: [
            {
                title: 'Recharge Package',
                to: 'Wallet',
            },
            {
                title: 'Payment History',
                to: 'paymenthistory',
            },
            {
                title: ' Users Payment History',
                to: 'userwalletTransaction',
            },
            {
                title: ' Astrologers Payment History',
                to: 'AstrowalletTransaction',
            },
            {
                title: ' Payment Page Visit Customers ',
                to: 'paymentpagevisitors',
            },
            {
                title: 'Astrologer Price Change ',
                to: 'astrologerpricechange',
            },

            {
                title: 'Refund List',
                to: 'Dashboard',
            },

            {
                title: 'Payment by Chat',
                to: 'Dashboard',
            },
            {
                title: 'Failed Transactions',
                to: 'Dashboard',
            },


           


        ],
    },
    {
        title: 'Company Transaction',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-lock" aria-hidden="true"></i>,
        content: [
            {
                title: 'Transaction',
                to: 'Transaction',
            },
            {
                title: 'Add Company',
                to: 'Addcompany',
            },

        ],
    },


    {
        title: 'Roles & Permissions',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-lock" aria-hidden="true"></i>,
        content: [
            {
                title: 'Set Permisssion',
                to: 'Dashboard',
            },

        ],
    },

    {
        title: 'Account Book',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-book" aria-hidden="true"></i>,
        content: [


            {
                title: 'Expense Details ',
                to: 'ExpenseDetails',
            },


            {
                title: 'Not Login Users',
                to: 'notloginuser',
            },
            {
                title: 'Payouts Processed',
                to: 'Dashboard',
            },
            {
                title: 'Operational Expense',
                to: 'Dashboard',
            },
            {
                title: 'Reviews & Approve',
                to: 'Dashboard',
            },

        ],
    },

    {
        title: 'Digital Marketing',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-bullhorn"></i>,
        content: [
            {
                title: 'Campaign Details',
                to: 'Dashboard',
            },
            {
                title: 'Daily Performance',
                to: 'Dashboard',
            },
            {
                title: 'Expense Tracking',
                to: 'Dashboard',
            },
        ],
    },

    {
        title: 'Feedback and Support',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-envelope"></i>,

        content: [

            {
                title: 'Ticket Category',
                to: 'TicketCategory',
            },
            {
                title: 'User Review',
                to: 'userreview',
            },
            {
                title: 'Customer Queries',
                to: 'Dashboard',
            },
            {
                title: 'Astro FeedBack',
                to: 'Dashboard',
            },

        ],
    },

    {
        title: 'Reports & Analytics',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-chart-line"></i>,

        content: [
            {
                title: 'Profit & Loss',
                to: 'Dashboard',
            },

        ],
    },

    {
        title: 'Appointment & Booking',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-calendar"></i>,

        content: [
            {
                title: 'Booking List',
                to: 'Dashboard',
            },
            {
                title: 'Assign Booking.',
                to: 'Dashboard',
            },
        ],
    },
    {
        title: 'Quality Assurance',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-calendar"></i>,

        content: [
            {
                title: 'Call Recordings',
                to: 'Dashboard',
            },

        ],
    },
    {
        title: 'All Menu Pages',
        classsChange: 'mm-collapse',
        iconStyle: <i class="fa fa-calendar"></i>,

        content: [
            {
                title: 'All Menu Pages',
                to: 'allmenupages',
            },

        ],
    },


]